import type React from 'react'
import { PointerSensor } from '@dnd-kit/core'

/**
 * Ob aus einem Druck auf eine Projekt-Zeile ein Zug werden darf: nur die Hauptmaustaste, kein
 * Ctrl-Klick (auf dem Mac der Rechtsklick) und nicht auf einem Knopf der Zeile (Pfeil, Tab).
 */
export function mayStartProjectDrag(event: PointerEvent): boolean {
  if (!event.isPrimary || event.button !== 0 || event.ctrlKey) return false
  const target = event.target as HTMLElement | null
  return !!target && !target.closest('button')
}

/** Zieht Projekt-Zeilen, lässt ihre Knöpfe in Ruhe. */
export class ProjectPointerSensor extends PointerSensor {
  static activators = [{
    eventName: 'onPointerDown' as const,
    handler: ({ nativeEvent: event }: React.PointerEvent) => mayStartProjectDrag(event),
  }]
}
